import { LoginComponent } from "@bindeleddet/core/components";
import React, { Dispatch, SetStateAction } from "react";
import { useLocation } from "react-router-dom";

interface Props {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const LoginButton: React.FC<Props> = ({ open, setOpen }) => {
  const { pathname } = useLocation();
  return (
    <LoginComponent
      type={open || pathname === "/" ? "default" : "primary"}
      text="Logg inn"
      onClick={() => setOpen(false)}
    />
  );
};

export default LoginButton;
